import ReactSelect from 'react-select';
import PropTypes from 'prop-types';

export const BuildingType = ({
  values,
  handleChangeCaracObj,
  errors,
  touched
}) => {
  const options = [
    { value: '', label: 'Seleccione' },
    { value: 1, label: 'Entre Medianeras' },
    { value: 2, label: 'Inteligente' },
    { value: 3, label: 'Primera Categoría' },
    { value: 4, label: 'Standard' },
    { value: 5, label: 'Tipo Block' },
    { value: 6, label: 'Torre' }
  ];
  return (
    <div>
      <label>Tipo</label>
      <ReactSelect
        name="buildingType"
        placeholder="-- Seleccione el estado --"
        options={options}
        value={options.find(v => v.value === values)}
        onChange={e => {
          handleChangeCaracObj('buildingType', e?.value && Number(e.value));
        }}
      />
      {errors?.type && touched?.type && (
        <label className="w-100 text-danger">{errors.type}</label>
      )}
    </div>
  );
};

BuildingType.propTypes = {
  values: PropTypes.object,
  handleChangeCaracObj: PropTypes.func,
  errors: PropTypes.object,
  touched: PropTypes.object
};
